"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
import React from "react";
import _ from "underscore";
import classNames from "classnames";
import Account from "../../api/account";
import Api from "../../api/api";
import DisablingButton from "../../components/disabling_button";
import ExceptionItem from "./exception_item";
import { EmbeddedElmComponent } from "./embedded_elm_components";
import loadHelper from "../loads";
import NewException, { INVOICE_CONTEXT } from "./new_exception";
import ruleFormatter from "../../formatters/rules";
import CarrierService from "../../services/carrier_service";
import { isClickableException } from "../../helpers/exceptions_advance_pages";
import {
  CARRIER_INVOICE_MODEL_OBJECT_TYPE,
  FACTOR_INVOICE_MODEL_OBJECT_TYPE,
  LOAD_SHIPMENT_MODEL_OBJECT_TYPE
} from "../../api/exception_events";
import * as popout from "./../popout";
import UnapproveBanner from "./unapprove_banner";
import DOMPurify from "dompurify";
import { addIcon, aiIcon, errorAlertIcon, successAlertIcon } from "../ui/icons";
import { Notification } from "../ui/v3/notification";
import { Button, ButtonSize, ButtonVariant } from "../ui/v3/button";
import { Tooltip, TooltipDirection, TooltipLocation } from "../ui/v3/tooltip";
import * as Pb from "../data/types/Pb";
const RulesAndExceptions = React.createClass({
  getDefaultProps: function() {
    return {
      exceptionEvents: [],
      decorator: function() {
        return null;
      }
    };
  },
  getInitialState: function() {
    return { loading: [] };
  },
  isLoadShipmentApproved: function() {
    return this.modelObjectType() === LOAD_SHIPMENT_MODEL_OBJECT_TYPE && this.props.loadShipment.state === "Approved";
  },
  isLoadShipmentBilled: function() {
    return this.modelObjectType() === LOAD_SHIPMENT_MODEL_OBJECT_TYPE && this.props.loadShipment.billed_in_tms;
  },
  billedNotification: function() {
    if (this.isLoadShipmentBilled()) {
      return /* @__PURE__ */ React.createElement("div", { className: "load-detail__shipment-final-header" }, "No action needed. Status: ", this.props.loadShipment.shipment_status, ".");
    }
    if (this.isLoadShipmentApproved()) {
      return /* @__PURE__ */ React.createElement("div", { className: "load-detail__shipment-final-header" }, "No action needed. Status: Approved.");
    }
    return null;
  },
  render: function() {
    if (this.props.v3ReskinEnabled) {
      return this.renderV3Reskin();
    }
    const objectTypeName = `${this.modelObjectType()}-exception`;
    const hasNoExceptions = this.numExceptions() === 0;
    return /* @__PURE__ */ React.createElement(
      "div",
      {
        "data-component": "RulesAndExceptions",
        className: `load-detail__rules ${objectTypeName}`
      },
      /* @__PURE__ */ React.createElement("div", { className: "rules__header" }, this.exceptionHeader()),
      /* @__PURE__ */ React.createElement(
        UnapproveBanner,
        {
          carrierInvoice: this.props.carrierInvoice,
          loadShipment: this.props.loadShipment,
          load: this.props.load
        }
      ),
      /* @__PURE__ */ React.createElement("div", { className: "rules__add-exception-container" }, this.newException()),
      this.billedNotification(),
      /* @__PURE__ */ React.createElement("ul", { className: "rules__list" }, hasNoExceptions ? this.emptyList() : [this.ruleList(), this.exceptionList()]),
      this.maybeShowDefaultPodDefinitionComponent()
    );
  },
  renderV3Reskin: function() {
    const divider = /* @__PURE__ */ React.createElement(
      "div",
      {
        style: {
          width: "100%",
          height: "1px",
          background: "var(--color-navy-400)"
        }
      }
    );
    const hasNoExceptions = this.numExceptions() === 0;
    const exceptions = () => {
      if (hasNoExceptions) {
        return this.emptyList();
      } else {
        const allExceptions = [this.ruleList(), this.exceptionList()].flat().map((row) => /* @__PURE__ */ React.createElement("div", { style: { margin: "0 var(--space-xs)" } }, row)).flatMap((section, i) => i == 0 ? [section] : [divider, section]);
        return /* @__PURE__ */ React.createElement(
          "div",
          {
            style: {
              display: "flex",
              flexDirection: "column",
              padding: "var(--space-xs) 0",
              gap: "var(--space-xs)",
              border: "1px solid var(--color-border-default)",
              borderRadius: "8px"
            }
          },
          allExceptions
        );
      }
    };
    return /* @__PURE__ */ React.createElement(
      "div",
      {
        style: {
          display: "flex",
          flexDirection: "column",
          gap: "var(--space-xs)"
        }
      },
      /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: "var(--space-xxs)" } }, this.exceptionHeaderV3Reskin()),
      this.newException(),
      /* @__PURE__ */ React.createElement(
        UnapproveBanner,
        {
          carrierInvoice: this.props.carrierInvoice,
          loadShipment: this.props.loadShipment,
          load: this.props.load,
          v3ReskinEnabled: true
        }
      ),
      exceptions(),
      this.maybeShowDefaultPodDefinitionComponent()
    );
  },
  exceptionHeader: function() {
    if (this.modelObjectType() === LOAD_SHIPMENT_MODEL_OBJECT_TYPE) {
      const model = this.modelObject();
      if (model.customer_id != null && model.customer_name != null)
        return /* @__PURE__ */ React.createElement("span", null, /* @__PURE__ */ React.createElement("h3", { className: "rules__header--title" }, model.customer_name, " (", model.shipment_external_id, ")", " ", this.showAlert(), " ", this.addExceptionButton()), this.billingRequirementsLink());
      else
        return /* @__PURE__ */ React.createElement("span", null, /* @__PURE__ */ React.createElement("h3", { className: "rules__header--title" }, "Missing Customer ", this.showAlert(), " ", this.addExceptionButton()), this.billingRequirementsLink());
    } else if (Account.auditBillingEnabled()) {
      const maybeCarrier = CarrierService.getCarrierOrUnknown(
        this.props.carrierInvoice.carrier_id
      );
      const carrier_name = maybeCarrier ? maybeCarrier.name : "Error " + Account.carrierTerm() + " not found";
      return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", { className: "indexer-header__subject" }, Account.carrierTerm(), " Exceptions"), /* @__PURE__ */ React.createElement("h3", { className: "rules__header--title" }, carrier_name, " ", this.showAlert(), " ", this.addExceptionButton()), this.billingRequirementsLink());
    } else
      return /* @__PURE__ */ React.createElement("span", null, /* @__PURE__ */ React.createElement("h3", { className: "rules__header--title" }, "Exceptions ", this.showAlert(), " ", this.addExceptionButton()), this.billingRequirementsLink());
  },
  exceptionHeaderV3Reskin: function() {
    const container = (els) => {
      return /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: "var(--space-xxxs)" } }, els, this.showAlert(), this.addExceptionButton());
    };
    if (this.modelObjectType() === LOAD_SHIPMENT_MODEL_OBJECT_TYPE) {
      const model = this.modelObject();
      if (model.customer_id != null && model.customer_name != null) {
        return container(
          /* @__PURE__ */ React.createElement("span", null, model.customer_name, " (", model.shipment_external_id, ")")
        );
      } else {
        return container(/* @__PURE__ */ React.createElement("span", null, "Missing Customer"));
      }
    } else if (Account.auditBillingEnabled()) {
      const maybeCarrier = CarrierService.getCarrierOrUnknown(
        this.props.carrierInvoice.carrier_id
      );
      const carrier_name = maybeCarrier ? maybeCarrier.name : "Error " + Account.carrierTerm() + " not found";
      return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("h4", null, Account.carrierTerm()), container(carrier_name));
    } else {
      return container(/* @__PURE__ */ React.createElement("h2", null, "Exceptions"));
    }
  },
  status: function() {
    const state = this.modelObject().state;
    if (this.modelObjectType() === LOAD_SHIPMENT_MODEL_OBJECT_TYPE && state && state.toLowerCase() == "exception") {
      const activeExceptionedItem = !!this.props.carrierInvoice && this.props.carrierInvoice.active_exceptioned_item;
      if (!!activeExceptionedItem && !!activeExceptionedItem.state && activeExceptionedItem.state.toLowerCase() != "unsent") {
        return activeExceptionedItem.state;
      } else {
        return "Exception";
      }
    } else {
      return this.modelObject().state;
    }
  },
  hasNoUnignoredExceptions: function() {
    return this.numExceptionsNotIgnored() === 0;
  },
  emptyList: function() {
    if (this.props.v3ReskinEnabled) {
      return /* @__PURE__ */ React.createElement(Notification, { message: "No exceptions" });
    } else {
      return /* @__PURE__ */ React.createElement("li", { className: "rules__all-pass" }, "No Exceptions");
    }
  },
  numExceptions: function() {
    return this.failureMessages().length + this.props.exceptionEvents.length;
  },
  numExceptionsNotIgnored: function() {
    const failures = this.failureMessages().filter((rule) => {
      return !loadHelper.ruleIsIgnored(this.modelObject(), rule);
    });
    return failures.length + this.props.exceptionEvents.length;
  },
  modelObject: function() {
    const objectLookup = {};
    objectLookup[LOAD_SHIPMENT_MODEL_OBJECT_TYPE] = this.props.loadShipment;
    objectLookup[CARRIER_INVOICE_MODEL_OBJECT_TYPE] = this.props.carrierInvoice;
    objectLookup[FACTOR_INVOICE_MODEL_OBJECT_TYPE] = this.props.factorInvoice;
    return objectLookup[this.modelObjectType()];
  },
  modelObjectType: function() {
    if (this.props.loadShipment) {
      return LOAD_SHIPMENT_MODEL_OBJECT_TYPE;
    } else if (this.props.carrierInvoice) {
      return CARRIER_INVOICE_MODEL_OBJECT_TYPE;
    } else {
      return FACTOR_INVOICE_MODEL_OBJECT_TYPE;
    }
  },
  failureMessages: function() {
    return this.modelObject() && this.modelObject().failure_messages || [];
  },
  ruleList: function() {
    const rules = this.failureMessages();
    const sortedRules = rules.sort((a, b) => {
      const aIsAutomated = a.rule_type === "plain_text_rule" && a.data.results_metadata && Object.keys(a.data.results_metadata).length > 0;
      const bIsAutomated = b.rule_type === "plain_text_rule" && b.data.results_metadata && Object.keys(b.data.results_metadata).length > 0;
      if (aIsAutomated && !bIsAutomated) return 1;
      if (!aIsAutomated && bIsAutomated) return -1;
      return 0;
    });
    return sortedRules.map(this.showRuleFailure);
  },
  isPodFailure: function(rule) {
    var _a;
    return rule.rule_type === "document_presence" && ((_a = rule.data) == null ? void 0 : _a.type) === "proofOfDelivery";
  },
  showRuleFailure: function(rule) {
    if (Account.podDefinitionModuleEnabled() && this.isPodFailure(rule)) {
      return this.showPodDefinitionComponentForRule(rule);
    }
    const ignored = loadHelper.ruleIsIgnored(this.modelObject(), rule);
    const message = ruleFormatter.rule(rule);
    const sanitizedMessage = DOMPurify.sanitize(message, {
      USE_PROFILES: { html: true }
    });
    const load = this.props.load;
    const possibleLoadNoteContext = this.possibleLoadNoteContext({
      rule,
      load: load && load.load
    });
    const possibleAdditionalDetails = this.possibleAdditionalDetails({
      rule
    });
    const possibleTooltip = this.possibleTooltip({ rule });
    if (this.props.v3ReskinEnabled) {
      const classes = classNames({
        v3__type__body: true,
        rules__ignored: ignored
      });
      return /* @__PURE__ */ React.createElement(
        "div",
        {
          style: {
            display: "flex",
            gap: "24px",
            justifyContent: "space-between",
            alignItems: "flex-start"
          },
          onClick: () => this.props.exceptionClicked(rule)
        },
        /* @__PURE__ */ React.createElement(
          "div",
          {
            style: {
              display: "flex",
              flexDirection: "column",
              alignSelf: "center"
            }
          },
          /* @__PURE__ */ React.createElement(
            "span",
            {
              className: classes,
              dangerouslySetInnerHTML: { __html: sanitizedMessage }
            }
          ),
          possibleLoadNoteContext,
          possibleAdditionalDetails
        ),
        this.ruleButtonV3Reskin(rule, ignored)
      );
    } else {
      const decoration = this.props.decorator(rule, sanitizedMessage);
      const classes = classNames({
        rules__ignored: ignored,
        "rules__item-text": true,
        rules__clickable: isClickableException(rule)
      });
      return /* @__PURE__ */ React.createElement(
        "li",
        {
          className: "rules__item",
          onClick: () => this.props.exceptionClicked(rule)
        },
        /* @__PURE__ */ React.createElement("span", { className: classes }, /* @__PURE__ */ React.createElement(
          "span",
          {
            className: "text",
            style: {
              display: "flex",
              alignItems: "center",
              gap: "4px",
              flexWrap: "wrap"
              // Allow wrapping if needed
            }
          },
          possibleTooltip,
          /* @__PURE__ */ React.createElement(
            "span",
            {
              dangerouslySetInnerHTML: { __html: sanitizedMessage }
            }
          ),
          " ",
          decoration,
          possibleLoadNoteContext,
          possibleAdditionalDetails
        )),
        this.ruleButton(rule, ignored)
      );
    }
  },
  buildPodComponentFlags: function(overrides) {
    var _a;
    return {
      componentFlags: {
        type: Pb.EmbeddedComponentsFlags_ComponentFlagsType.PODDefinition,
        pod_definition: __spreadValues({
          display_text: "",
          unskippable: false,
          ignored: false,
          read_only: this.props.readOnly || false,
          carrier_invoice_id: (_a = this.props.carrierInvoice) == null ? void 0 : _a.id,
          rule_json: "",
          validation_error_messages: [],
          rule_failure_exists: false,
          ocr_drop_zone_class: "pod-definition__ocr-drop-zone"
        }, overrides)
      }
    };
  },
  maybeShowDefaultPodDefinitionComponent: function() {
    var _a;
    if (!Account.podDefinitionModuleEnabled()) {
      return null;
    }
    if (((_a = this.props.carrierInvoice) == null ? void 0 : _a.pod_requirement_skipped) === true) {
      return null;
    }
    if (this.failureMessages().some((r) => this.isPodFailure(r))) {
      return null;
    }
    return /* @__PURE__ */ React.createElement("div", { className: "rules__default-pod-definition" }, /* @__PURE__ */ React.createElement(
      EmbeddedElmComponent,
      {
        componentFlags: this.buildPodComponentFlags({})
      }
    ));
  },
  showPodDefinitionComponentForRule: function(rule) {
    var _a, _b;
    const ignored = loadHelper.ruleIsIgnored(this.modelObject(), rule);
    return /* @__PURE__ */ React.createElement(
      EmbeddedElmComponent,
      {
        componentFlags: this.buildPodComponentFlags({
          display_text: rule.display_text,
          unskippable: ((_a = rule.data) == null ? void 0 : _a.unskippable) || false,
          ignored: !!ignored,
          carrier_invoice_id: this.props.carrierInvoice.id,
          rule_json: JSON.stringify(rule),
          validation_error_messages: ((_b = rule.data) == null ? void 0 : _b.validation_error_messages) || [],
          rule_failure_exists: true
        })
      }
    );
  },
  possibleAdditionalDetails({ rule }) {
    if (rule.display_text_details) {
      return rule.display_text_details.map(
        (item, index) => this.additionalDetail(item.text)
      );
    }
  },
  possibleLoadNoteContext({ rule, load }) {
    if (load && load.data && rule && rule.rule_type === "note_on_load") {
      switch (rule.failure_type) {
        case "load_note":
          return this.additionalDetail(load.data.load_note);
        case "payables_note":
          return this.additionalDetail(load.data.payables_note);
      }
    }
  },
  additionalDetail: function(note) {
    if (this.props.v3ReskinEnabled) {
      return /* @__PURE__ */ React.createElement(
        "div",
        {
          className: "v3__type__small-body",
          style: { color: "var(--color-grayscale-600)" }
        },
        note
      );
    } else {
      return /* @__PURE__ */ React.createElement("span", { className: "rules__additional_details" }, note);
    }
  },
  possibleTooltip({ rule }) {
    if (Account.automateCustomExceptionMessages() && rule.rule_type === "plain_text_rule" && rule.data.results_metadata) {
      const hasMetadata = Object.keys(rule.data.results_metadata).length > 0;
      const hasFunctionResults = rule.data.results_metadata.function_results && Object.keys(rule.data.results_metadata.function_results).length > 0;
      if (hasMetadata && hasFunctionResults) {
        return this.ruleTooltip(rule.data.results_metadata);
      }
    }
    return null;
  },
  ruleTooltip: function(metadata) {
    const tooltipText = this.formatMetadataForTooltip(metadata);
    return /* @__PURE__ */ React.createElement("span", { className: "enable_shared-ui-v3" }, /* @__PURE__ */ React.createElement("div", { className: "v3__theme" }, /* @__PURE__ */ React.createElement(
      Tooltip,
      {
        content: /* @__PURE__ */ React.createElement(
          "span",
          {
            style: {
              display: "inline-block",
              filter: "none",
              transition: "filter 0.2s ease"
            },
            onMouseEnter: (e) => {
              e.currentTarget.style.filter = "brightness(0)";
            },
            onMouseLeave: (e) => {
              e.currentTarget.style.filter = "none";
            }
          },
          aiIcon()
        ),
        tooltipContent: tooltipText,
        direction: TooltipDirection.Below,
        location: TooltipLocation.Hidden,
        tooltipContentStyle: {
          width: "auto",
          minWidth: "200px",
          maxWidth: "500px",
          whiteSpace: "pre-line"
        }
      }
    )));
  },
  formatMetadataForTooltip: function(metadata) {
    const hasFailures = Object.values(metadata).some(
      (value) => value === false
    );
    const headerText = hasFailures ? "Exception failed automation" : "Exception check automated";
    const functionMetadata = metadata.function_results || {};
    const description = metadata.description || "";
    const entries = Object.entries(functionMetadata).map(([key, value]) => {
      const readable = key.replace(/_/g, " ").replace(/\b\w/g, (l) => l.toUpperCase());
      const statusIcon = value ? /* @__PURE__ */ React.createElement(
        "span",
        {
          style: {
            marginRight: "4px",
            paddingBottom: "2px",
            display: "flex"
          }
        },
        successAlertIcon()
      ) : /* @__PURE__ */ React.createElement(
        "span",
        {
          style: {
            marginRight: "4px",
            paddingBottom: "2px",
            display: "flex"
          }
        },
        errorAlertIcon()
      );
      return /* @__PURE__ */ React.createElement(
        "div",
        {
          key,
          style: { display: "flex", alignItems: "center", marginBottom: "2px" }
        },
        statusIcon,
        /* @__PURE__ */ React.createElement("span", null, readable)
      );
    });
    return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(
      "div",
      {
        style: { fontWeight: "bold", marginBottom: "8px", minWidth: "300px" }
      },
      headerText
    ), /* @__PURE__ */ React.createElement("div", { style: { marginBottom: "8px" } }, " ", description, " "), /* @__PURE__ */ React.createElement("div", null, entries));
  },
  showAlert: function() {
    if (!this.hasNoUnignoredExceptions()) {
      if (this.props.v3ReskinEnabled) {
        const num = this.numExceptionsNotIgnored();
        const countClass = 0 <= num && num <= 9 ? "v3__badge-count--single-digit" : "";
        return /* @__PURE__ */ React.createElement("span", { className: "v3__badge v3__badge--alert v3__badge--size-default" }, /* @__PURE__ */ React.createElement("span", { className: `v3__badge-count ${countClass}` }, num));
      } else {
        return /* @__PURE__ */ React.createElement("span", { className: "round alert label rules__header__alert" }, this.numExceptionsNotIgnored());
      }
    }
  },
  ruleButton: function(rule, ignored) {
    if (rule.data.unskippable) {
      return /* @__PURE__ */ React.createElement(
        "button",
        {
          disabled: true,
          className: "rules__ignore-button rules__ignore-button--disabled"
        },
        "Required"
      );
    }
    if (!this.props.readOnly) {
      if (ignored) {
        return /* @__PURE__ */ React.createElement(
          DisablingButton,
          {
            onClick: (event) => {
              event.preventDefault();
              event.stopPropagation();
              this.enableRule(rule);
            },
            disabled: this.isLoading(rule),
            disabledText: "Enabling...",
            disabledClassName: "rules__ignore-button rules__ignore-button--disabled",
            className: "rules__ignore-button"
          },
          "Enable"
        );
      }
      return /* @__PURE__ */ React.createElement(
        DisablingButton,
        {
          onClick: (event) => {
            event.preventDefault();
            event.stopPropagation();
            this.ignoreRule(rule);
          },
          disabled: this.isLoading(rule),
          disabledText: "Ignoring...",
          disabledClassName: "rules__ignore-button rules__ignore-button--disabled",
          className: "rules__ignore-button"
        },
        "Ignore"
      );
    }
  },
  ruleButtonV3Reskin: function(rule, ignored) {
    if (rule.data.unskippable) {
      return /* @__PURE__ */ React.createElement(
        Button,
        {
          size: ButtonSize.Medium,
          variant: ButtonVariant.Outlined,
          disabled: true
        },
        "Required"
      );
    }
    if (!this.props.readOnly) {
      const isLoading = this.isLoading(rule);
      if (ignored) {
        return /* @__PURE__ */ React.createElement(
          Button,
          {
            size: ButtonSize.Medium,
            onClick: (event) => {
              event.preventDefault();
              event.stopPropagation();
              this.enableRule(rule);
            },
            disabled: isLoading,
            variant: ButtonVariant.Outlined
          },
          isLoading ? "Enabling..." : "Enable"
        );
      }
      return /* @__PURE__ */ React.createElement(
        Button,
        {
          size: ButtonSize.Medium,
          onClick: (event) => {
            event.preventDefault();
            event.stopPropagation();
            this.ignoreRule(rule);
          },
          disabled: isLoading,
          variant: ButtonVariant.Outlined
        },
        isLoading ? "Ignoring..." : "Ignore"
      );
    }
  },
  isLoading: function(rule) {
    return this.state.loading.indexOf(rule) >= 0;
  },
  startLoading: function(rule) {
    this.setState({ loading: this.state.loading.concat([rule]) });
  },
  doneLoading: function(rule) {
    return () => {
      this.setState({ loading: _.without(this.state.loading, rule) });
    };
  },
  enableRule: function(rule) {
    this.startLoading(rule);
    const done = this.doneLoading(rule);
    Api.Rules.enable(this.modelObject().id, rule, this.modelObjectType()).then(done).catch(done);
  },
  ignoreRule: function(rule) {
    this.startLoading(rule);
    const done = this.doneLoading(rule);
    Api.Rules.ignore(this.modelObject().id, rule, this.modelObjectType()).then(done).catch(done);
  },
  exceptionList: function() {
    return this.props.exceptionEvents.map(this.showException);
  },
  newException: function() {
    if (this.state.adding) {
      return /* @__PURE__ */ React.createElement(
        NewException,
        {
          context: INVOICE_CONTEXT,
          customExceptionOnly: true,
          exceptionCreator: this.createException,
          onCancel: this.cancelNewException,
          modelObjectType: this.modelObjectType(),
          v3ReskinEnabled: this.props.v3ReskinEnabled
        }
      );
    }
  },
  createException: function(message, ignore, types) {
    return this.props.exceptionCreator(message, ignore, types).then(() => {
      this.setState({ adding: false });
    });
  },
  cancelNewException: function() {
    this.setState({ adding: false });
  },
  addExceptionButton: function() {
    if (this.isLoadShipmentApproved()) {
      return;
    }
    if (this.isLoadShipmentBilled()) {
      return;
    }
    if (this.state.adding) {
      return;
    }
    if (!this.props.exceptionCreator) {
      return;
    }
    if (this.props.readOnly) {
      return;
    }
    if (this.props.v3ReskinEnabled) {
      return /* @__PURE__ */ React.createElement(
        Button,
        {
          size: ButtonSize.Small,
          variant: ButtonVariant.Text,
          style: { padding: 0 },
          onClick: () => {
            this.setState({ adding: true });
          }
        },
        addIcon(),
        /* @__PURE__ */ React.createElement("span", null, "Add")
      );
    } else {
      return /* @__PURE__ */ React.createElement(
        "a",
        {
          onClick: () => {
            this.setState({ adding: true });
          }
        },
        /* @__PURE__ */ React.createElement("i", { className: "fi-plus" })
      );
    }
  },
  showException: function(exception) {
    return /* @__PURE__ */ React.createElement(
      ExceptionItem,
      {
        exception,
        exceptionResolver: this.props.exceptionResolver,
        owner: this.props.load,
        v3ReskinEnabled: this.props.v3ReskinEnabled
      }
    );
  },
  billingRequirementsLink: function() {
    const loadShipment = this.props.loadShipment;
    let customerId;
    let showAlertIcon;
    let isHidden;
    if (Account.auditBillingEnabled()) {
      if (loadShipment && this.modelObjectType() === LOAD_SHIPMENT_MODEL_OBJECT_TYPE) {
        customerId = loadShipment.customer_id;
        showAlertIcon = loadShipment.customer_instructions && loadShipment.customer_instructions.length > 0;
      } else {
        isHidden = true;
      }
    } else {
      const tmsLoadShipments = this.props.load && this.props.load.load && this.props.load.load.tms_load_shipments || [];
      showAlertIcon = tmsLoadShipments.some(
        (shipment) => shipment.customer_instructions && shipment.customer_instructions.length > 0
      );
    }
    if (this.useBillingReqsPopout() && !isHidden) {
      const tooltipText = "Customer instructions are present";
      return /* @__PURE__ */ React.createElement("div", { className: "rules__header--details" }, /* @__PURE__ */ React.createElement("a", { onClick: () => this.openBillingReqsPopout(customerId) }, showAlertIcon && /* @__PURE__ */ React.createElement("span", { className: "popup__wrapper" }, /* @__PURE__ */ React.createElement("span", { className: "popup" }, tooltipText), /* @__PURE__ */ React.createElement("span", { className: "icon-alert" })), "Customer Details"));
    }
  },
  openBillingReqsPopout(customerId) {
    popout.setCustomerId(customerId);
    popout.openOrFocusBillingReqsPopout();
  },
  useBillingReqsPopout() {
    return Account.useBillingReqsPopout() && Account.hasRole("Broker");
  }
});
export default RulesAndExceptions;
